import {useEffect, useState} from "react";
import FlexSearch from "flexsearch";

export const useFlexSearchIndex = (providedIndex) => {
  const [index, setIndex] = useState(null);

  useEffect(() => {
    if (providedIndex instanceof FlexSearch) {
      setIndex(providedIndex);
      return;
    }

    const flexsearchIndex = FlexSearch.create({
      encode: false,
      tokenize: 'reverse',
      suggest: true,
      threshold: 1,
      resolution: 9,
      depth: 4
    });
    if (providedIndex) {
      flexsearchIndex.import(providedIndex);
    }

    setIndex(flexsearchIndex);
  }, []);

  return index;
};
